import React, { useState, useEffect } from "react";
import { Result } from "antd";
import { connect } from "react-redux";

const OsimisViewer = ({ match, authenticated }) => {
    const [url, setUrl] = useState(null);
    useEffect(() => {
        const dataString = localStorage.getItem('osimis_storage');
        if (dataString && dataString !== "") {
            const data = JSON.parse(dataString);
            if (data[match.params.id]) {
                setUrl(data[match.params.id]);
            } else {
                setUrl(null);
                localStorage.removeItem('osimis_storage');
            }
        }
    }, [match.params.id]);
    return (
        <div
            style={{
                width: "100%",
                height: "100%"
            }}
        >
            {
                authenticated && url ?
                    <embed
                        src={url}
                        width="100%"
                        height="100%"
                        onerror="alert('URL invalid !!');"
                    /> :
                    !authenticated ?
                        <Result
                            status="403"
                            title="403"
                            subTitle="Sorry, you are not authorized to access this page."
                        /> :
                        <Result
                            status="404"
                            title="404"
                            subTitle="Sorry, the page you visited does not exist."
                        />

            }
        </div>
    );
}


const mapStateToProps = ({ auth }) => {
    const { authUser } = auth;
    return {
        authenticated: authUser ? authUser.authenticated : false
    }
};

export default connect(mapStateToProps, null)(OsimisViewer);
